import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env';

export const schemaInterceptor: HttpInterceptorFn = (req, next) => {
	if (
		req.url.includes(environment.baseUrl) ||
		req.url.includes(environment.publicAuthUrl) ||
		req.url.includes(environment.openBaseUrl)
	) {
		let subdomain: string = window.location.hostname.split('.')[0];
		if (subdomain === 'localhost') {
			subdomain = 'lawyal';
		}
		req = req.clone({
			setHeaders: { schema: subdomain }
		});
	}
	return next(req);
};
